import React from 'react'
import './expertise.css'
import { FaHospital, FaShieldAlt, FaRobot, FaChartLine } from 'react-icons/fa'

const Expertise = () => {
  return (
    <section id='expertise'>
      <h5>Real-World Impact</h5>
      <h2>Domain Expertise</h2>
      
      <div className='container expertise__container'>
        <div className='expertise__intro'>
          <h3>Production-Grade Systems, Not Toy Projects</h3>
          <p>
            I build <strong>enterprise-level software</strong> that solves real problems for governments, healthcare institutions, and businesses. My experience spans complex, multi-role systems with thousands of users.
          </p>
        </div>

        <div className='expertise__grid'>
          <article className='expertise__card'>
            <div className='expertise__icon'>
              <FaHospital />
            </div>
            <h4>Healthcare Systems</h4>
            <ul>
              <li>Patient-Doctor-Pharmacist platforms</li>
              <li>Electronic Health Records (EHR)</li>
              <li>Telehealth solutions (Mobile & Web)</li>
              <li>Tablet-locked hospital apps (kiosk-style)</li>
              <li>QR-based workflows & receipt printing</li>
            </ul>
            <span className='expertise__badge'>Production</span>
          </article>

          <article className='expertise__card'>
            <div className='expertise__icon'>
              <FaShieldAlt />
            </div>
            <h4>Enterprise Solutions</h4>
            <ul>
              <li>Anti-ghost-worker systems (Gov/Banks)</li>
              <li>Employee & attendance management</li>
              <li>Internal revenue systems</li>
              <li>School management platforms</li>
              <li>Secure OTP authentication flows</li>
            </ul>
            <span className='expertise__badge'>Enterprise</span>
          </article>

          <article className='expertise__card'>
            <div className='expertise__icon'>
              <FaRobot />
            </div>
            <h4>AI Integration</h4>
            <ul>
              <li>AI-powered chatbots (MediBot)</li>
              <li>Decision-support systems</li>
              <li>Healthcare AI applications</li>
              <li>Productivity automation</li>
              <li>AI-powered SaaS platforms</li>
            </ul>
            <span className='expertise__badge'>Innovation</span>
          </article>

          <article className='expertise__card'>
            <div className='expertise__icon'>
              <FaChartLine />
            </div>
            <h4>Product Mindset</h4>
            <ul>
              <li>MVP development for startups</li>
              <li>Investor-ready products</li>
              <li>UX psychology & conversion</li>
              <li>Cost-saving system architecture</li>
              <li>Scalable, maintainable code</li>
            </ul>
            <span className='expertise__badge'>Strategic</span>
          </article>
        </div>

        <div className='expertise__cta'>
          <h3>🎯 Career Direction</h3>
          <p>
            Seeking <strong>remote roles</strong> with <strong>global companies and startups</strong> in <strong>health-tech and enterprise software</strong>. I'm a high-impact engineer who builds beautiful UIs, complex systems, and real-world solutions that drive business value.
          </p>
          <a href='#contact' className='btn btn-primary'>Let's Build Something Great</a>
        </div>
      </div>
    </section>
  )
}

export default Expertise
